import { render } from "./Breadcrumbs.vue?vue&type=template&id=3fe876ec&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=3fe876ec&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe876ec"]])

export default __exports__